module.exports = __webpack_public_path__ + "static/vanishing-words-11c2742db89626fb91263f12c5786c89.jpg";